import { connect } from 'react-redux';

import { PlacesServiceStatus } from 'ha/types/GoogleMaps';
import reportError from 'ha/helpers/bugsnag/reportError';
import Locations from './Locations';

// for more info please visit: https://developers.google.com/maps/documentation/javascript/reference/places-service#PlacesServiceStatus
const PLACES_STATUS_TO_REPORT = [
  PlacesServiceStatus.INVALID_REQUEST,
  PlacesServiceStatus.OVER_QUERY_LIMIT,
  PlacesServiceStatus.UNKNOWN_ERROR,
  PlacesServiceStatus.REQUEST_DENIED,
  PlacesServiceStatus.OVER_DAILY_LIMIT,
];

// This is our workaround to manage in a better way the injection of the services from a thunk
// The main idea here is to abstract the container of the creation of the autocompleteService
// and only manage getPlacePredictions because in the future this can be changed/replaced with another service
// main issue about services in thunks: https://github.com/housinganywhere/ha/pull/5221
export const loadSuggestionsService = ({ value, predictionTypes }) => (
  _,
  __,
  { googleMapApi },
) =>
  googleMapApi.init().then(
    autocompleteService =>
      new Promise((resolve, reject) => {
        autocompleteService.getPlacePredictions(
          {
            input: value,
            types: predictionTypes,
          },
          (results, status) => {
            if (status === PlacesServiceStatus.OK) {
              resolve(results);
            }

            if (status === PlacesServiceStatus.ZERO_RESULTS) {
              resolve([]);
            }

            if (PLACES_STATUS_TO_REPORT.includes(status)) {
              reportError(`location input error ${status}`);
              reject(new Error(status));
            }

            reject(new Error(status));
          },
        );
      }),
  );

export default connect(
  null,
  (dispatch, { predictionTypes }) => ({
    loadSuggestions: value =>
      dispatch(loadSuggestionsService({ value, predictionTypes })),
  }),
)(Locations);
